import { FleetMaintenanceAreaRoutes } from '@backoffice-frontend/fleet-maintenance-api'
import type { AreaNavigationProps } from '@backoffice-frontend/patterns'
import { NavigationItem } from '@backoffice-frontend/patterns'
import { WrenchIcon } from '@moia-dev/pace-icons'
import { FleetMaintenanceAreaDataTestIds } from './FleetMaintenanceAreaDataTestIds'

export const FleetMaintenanceAreaNavigationIcon = WrenchIcon

export const FleetMaintenanceAreaNavigation = ({
  onClick,
  open,
  label,
}: AreaNavigationProps) => {
  return (
    <NavigationItem
      onClick={onClick}
      open={open}
      label={label}
      to={FleetMaintenanceAreaRoutes.route}
      Icon={WrenchIcon}
      dataTestId={FleetMaintenanceAreaDataTestIds.Navigation}
    />
  )
}
